import { render, staticRenderFns } from "./ConsultantRolePromotionSidebar.vue?vue&type=template&id=004177e8"
import script from "./ConsultantRolePromotionSidebar.vue?vue&type=script&lang=js"
export * from "./ConsultantRolePromotionSidebar.vue?vue&type=script&lang=js"
import style0 from "./ConsultantRolePromotionSidebar.vue?vue&type=style&index=0&id=004177e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports